// extracted by mini-css-extract-plugin
export default {"arrows":"NavigationArrows_arrows__E1MWG","button":"NavigationArrows_button__DkRyA","loader":"NavigationArrows_loader__Z6Fww"};